<template>
  <div>
    <BreadCrumd
      :title="'Gestion des évènements'"
      :description="'Aperçu d\'un évènement'"
    />
    <div class="mt-4 mb-4">
      <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
        <alert-error
          v-if="form.errors.get('message')"
          :form="form"
          :message="form.errors.get('message')"
        ></alert-error>

        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body mb-n2">
                <div class="row d-flex justify-content-center">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="titre"
                        >Titre Evènement
                        <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('titre'),
                        }"
                        id="titre"
                        v-model="form.titre"
                        type="text"
                        placeholder="Titre de l'évènement"
                        maxlength="100"
                        required
                        disabled
                      />
                      <has-error :form="form" field="titre"></has-error>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="type_evenement"
                        >Type Evènement
                        <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('type_evenement'),
                        }"
                        id="type_evenement"
                        v-model="form.type_evenement_nom"
                        type="text"
                        placeholder="Type de l'évènement"
                        maxlength="100"
                        required
                        disabled
                      />
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <label for="date_debut"
                        >Date début <span class="text-danger">*</span></label
                      >
                      <date-picker
                        v-model="form.date_debut"
                        type="datetime"
                        name="date_debut"
                        placeholder="Date début"
                        lang="fr"
                        format="DD/MM/YYYY HH:mm"
                        value-type="DD/MM/YYYY HH:mm"
                        :minute-step="5"
                        disabled
                      ></date-picker>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <label for="date_fin"
                        >Date fin <span class="text-danger">*</span></label
                      >
                      <date-picker
                        v-model="form.date_fin"
                        type="datetime"
                        name="date_fin"
                        placeholder="Date fin"
                        lang="fr"
                        format="DD/MM/YYYY HH:mm"
                        value-type="DD/MM/YYYY HH:mm"
                        :minute-step="5"
                        disabled
                      ></date-picker>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="description"
                        >Description de l'évènement</label
                      >
                      <textarea
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('description'),
                        }"
                        rows="5"
                        id="description"
                        v-model="form.description"
                        type="text"
                        placeholder="Description de l'évènement"
                        disabled
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-4 mt-2">
          <div class="col-md-12 text-right">
            <button
              type="button"
              class="btn btn-secondary mr-4"
              @click.prevent="
                $router.push({ name: 'evenement' }).catch(() => {})
              "
            >
              Liste des évènements
            </button>

            <button
              type="button"
              class="btn btn-custom-primary"
              style="min-width: 100px"
              @click.prevent="
                $router
                  .push({
                    name: 'evenement-edit',
                    params: { id: id },
                  })
                  .catch(() => {})
              "
            >
              Modifier
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import URL from '@/http/agenda/evenement';
import Form from 'vform';
import DatePicker from 'vue2-datepicker';

export default {
  data() {
    return {
      form: new Form({
        date_debut: '',
        date_fin: '',
        titre: '',
        description: '',
        type_evenement: '',
        type_evenement_nom: '',
      }),
      title: 'Gestion des évènements - Aperçu',
    };
  },
  components: {
    DatePicker,
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    init() {
      this.id = this.$route.params.id;

      window.axios
        .get(URL.EVENEMENT + '/' + this.id)
        .then((resp) => {
          Object.assign(this.form, resp.data.evenement);
        })
        .catch();
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
